import { render, staticRenderFns } from "./MercadoPagoPOSController.vue?vue&type=template&id=0c7251a9&"
import script from "./MercadoPagoPOSController.vue?vue&type=script&lang=js&"
export * from "./MercadoPagoPOSController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports